import React from "react";
import { Layout, Dropdown, Button, Typography, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useAccount, useDisconnect, usePublicClient } from "wagmi";
import '../styles/TopNavbar.css'; // Corrected import path

const { Header } = Layout;
const { Text } = Typography;

const TopNavbar: React.FC = () => {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const publicClient = usePublicClient();

  const formatAddress = (addr: string) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <Text strong>Network:</Text> {publicClient?.chain?.name || "Unknown"}
      </Menu.Item>
      <Menu.Item key="2">
        <Text strong>Address:</Text> {address ? formatAddress(address) : "N/A"}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <Button
          style={{ width: "100%", background: "#ff4d4f", color: "white" }}
          onClick={() => disconnect()}
        >
          Disconnect Wallet
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <Header
      className="topbar" // Use the class from CSS file
    >
      <Text strong>dSoftGames Dashboard</Text>
      {isConnected && (
        <Dropdown overlay={menu} trigger={['click']}>
          <div>
          <Button className="walletButton">
            {address ? formatAddress(address) : "Connect Wallet"} <DownOutlined />
          </Button>
          </div>
        </Dropdown>
      )}
    </Header>
  );
};

export default TopNavbar;
